import { Button, Input, Title } from "../../uikit";
import Header from "../Header";
import { useNavigate } from "react-router";

import { useTranslation } from "react-i18next";

import { DOMAIN } from "../../consts";
import { useState } from "react";
import ErrorMessage from "../ErrorMessage";
import getMiniappInitData from "../../telegramMiniapp";
import styles from "../../pages/login.module.css";
import { getUserData } from "../../utils/Api";
import { saveToken, clearToken } from "../../utils/tokenStorage";

export default function LoginEmail({ setVariant = () => {} }) {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isPasswordChangeRequired, setIsPasswordChangeRequired] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const finishLogin = async (token) => {
    saveToken(token);
    const [success, profile] = await getUserData();
    if (!success) {
      clearToken();
      setErrorMessage("Something went wrong");
      return;
    }
    localStorage.setItem("lang", profile.lang);
    // localStorage.setItem("theme", profile.theme);
    navigate("/account");
  };

  const login = async () => {
    try {
      setIsLoading(true);
      if (username == "" || password == "") {
        setErrorMessage("Fill all fields");
        return;
      }
      setErrorMessage("");
      const data = {
        username,
        password,
      };
      const authData = getMiniappInitData();
      if (authData?.tgWebAppData) {
        data.telegram_data = authData?.tgWebAppData;
      }
      const result = await fetch(DOMAIN + "/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((r) => r.json());
      if (result.success) {
        if (result.password_change_required) {
          setIsPasswordChangeRequired(true);
          return;
        }
        await finishLogin(result.token);
      } else {
        let message = "Something went wrong";
        if (result.message != "") {
          message = result.message;
        }
        setErrorMessage(message);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const changePassword = async () => {
    try {
      setIsLoading(true);
      if (username == "" || password == "" || newPassword == "") {
        setErrorMessage("Fill all fields");
        return;
      }
      setErrorMessage("");
      const result = await fetch(DOMAIN + "/auth/change-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
          new_password: newPassword,
        }),
      }).then((r) => r.json());

      if (result.success) {
        setIsPasswordChangeRequired(false);
        await finishLogin(result.token);
      } else {
        let message = "Something went wrong";
        if (result.message != "") {
          message = result.message;
        }
        setErrorMessage(message);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const submit = () => {
    if (isPasswordChangeRequired) {
      changePassword();
      return;
    }
    login();
  };

  return (
    <div className="column card wide">
      <Header
        isBack={true}
        backCallback={() => setVariant("start")}
        className="row"
      >
        <Title level="1" weight="3">
          {t("Login")}
        </Title>
      </Header>
      {!isPasswordChangeRequired && (
        <>
          <Input
            className="wide"
            header={t("Email")}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            type="password"
            className="wide mb-1"
            header={t("Password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !isLoading) {
                e.preventDefault();
                login();
              }
            }}
          />
        </>
      )}
      {isPasswordChangeRequired && (
        <>
          <p className={`${styles.passwordChangeHint} mb-1`}>
            {t("Password change required. Please enter a new password.")}
          </p>
          <Input
            type="password"
            className="wide mb-1"
            header={t("New password")}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !isLoading) {
                e.preventDefault();
                changePassword();
              }
            }}
          />
        </>
      )}
      <ErrorMessage errorMessage={errorMessage} />
      <Button
        mode="filled"
        size="l"
        className="row"
        onClick={submit}
        loading={isLoading}
        disabled={isLoading}
      >
        {isPasswordChangeRequired ? t("Change password") : t("ToLogin")}
      </Button>
      {!isPasswordChangeRequired && (
        <>
          <Button
            mode="outline"
            size="l"
            className="row"
            onClick={() => setVariant("signup-email")}
          >
            {t("Signup")}
          </Button>
          <Button
            mode="outline"
            size="l"
            className="row"
            onClick={() => setVariant("password-recovery")}
          >
            {t("Password recovery")}
          </Button>
        </>
      )}
    </div>
  );
}

